// frontend/src/pages/LandingPage.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROUTES } from "../config";
import Hero from "../components/landing/Hero";
import AgentTimeline from "../components/landing/AgentTimeline";
import FeatureGrid from "../components/landing/FeatureGrid";
import ResearchCard from "../components/landing/ResearchCard";
import CTA from "../components/landing/CTA";
import "./LandingPage.css";

/**
 * Public landing page. Rendered at "/" and at "/login" (where PublicLayout
 * opens the login modal on top of it).
 */
export default function LandingPage() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.title = "PAWNI — Ask the question you actually mean";
  }, []);

  // Scroll to "#how-it-works" / "#research" when the hash changes.
  useEffect(() => {
    if (!location.hash) return undefined;
    const id = decodeURIComponent(location.hash.slice(1));
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (!el) return;
      const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    }, 40);
    return () => clearTimeout(t);
  }, [location.hash, location.key]);

  const start = () => {
    if (isAuthenticated) navigate(ROUTES.app);
    else navigate(ROUTES.login, { state: { from: { pathname: ROUTES.app } } });
  };
  const startLabel = isAuthenticated ? "Open the app" : "Start building";

  return (
    <div className="landing">
      <Hero onStart={start} startLabel={startLabel} />
      <AgentTimeline />
      <FeatureGrid />
      <ResearchCard />
      <CTA onStart={start} startLabel={startLabel} />
    </div>
  );
}
